import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'
import { Modal } from 'antd'

export const LanguageDetectionModal: FC<{
  isOpened: boolean
  onClose: () => void
  onConfirm: () => void
  fromLanguage?: string
  detectedLanguage?: string
}> = ({ isOpened, onClose, onConfirm, fromLanguage, detectedLanguage }) => {
  const { t } = useTranslation('common')

  return (
    <StyledModal
      centered
      open={isOpened}
      onOk={onConfirm}
      onCancel={onClose}
      width={500}
      style={{ borderRadius: 10 }}
      footer={null}
    >
      <div>
        <h1 style={{ margin: '0', fontSize: 16, textAlign: 'center' }}>
          {t('Other language detected in the script')}
        </h1>
        <p style={{ textAlign: 'center', margin: 0 }}>
          {t('Change to a suitable voice automatically?')}
        </p>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 24,
          }}
        >
          <div
            style={{
              border: '1px solid white',
              borderRadius: 8,
              padding: 2,
              paddingRight: 8,
              paddingLeft: 8,
              marginRight: 8,
            }}
          >
            {t('Current')}
          </div>
          <div style={{ marginRight: 12, fontSize: 16 }}>{fromLanguage}</div>

          <div
            style={{
              border: '1px solid white',
              borderRadius: 8,
              padding: 2,
              paddingRight: 8,
              paddingLeft: 8,
              marginRight: 8,
            }}
          >
            {t('Detected')}
          </div>
          <div style={{ fontSize: 16 }}>{detectedLanguage}</div>
        </div>
      </div>

      <div
        style={{
          marginTop: 32,
          display: 'flex',
          alignItems: 'center',
          marginLeft: 'auto',
          marginRight: 0,
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            cursor: 'pointer',
            marginRight: 10,
            width: 160,
            height: 38,
            display: 'grid',
            placeItems: 'center',
            borderRadius: 4,
            border: '1px solid #ccc',
          }}
          onClick={onClose}
        >
          {t('No')}
        </div>
        <div
          style={{
            cursor: 'pointer',
            width: 160,
            height: 38,
            display: 'grid',
            placeItems: 'center',
            backgroundColor: '#3075f6',
            color: 'white',
            borderRadius: 4,
          }}
          onClick={onConfirm}
        >
          {t('Yes')}
        </div>
      </div>
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  background-color: #373839;

  .ant-modal-content {
    padding-right: 40px;
    padding-left: 40px;
    padding-top: 30px;
    background-color: #373839;
    color: white;
  }
`
